/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Box, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { npDeptSigningFlows, npSigningFlows, rpDeptSigningFlows, rpSigningFlows } from '../../NoteOfPresentation/utils';
import DataLoading from '../../../components/DataLoading';
import Print from '../../NoteOfPresentation/components/print';

const Q_DETAIL = gql`
	query get($id: String!) {
		getNpById(id: $id) {
			id
			createdBy
			createdAt
			step
			number
			subject
			references
			description
			attachings
			attachments
			proposalNumber
			type
			office
			department
			completedAt
			createdByUser {
				id
				username
				fullName
				fullNameKhmer
				avatar
			}
			viewers {
				id
				createdAt
				createdBy
				userViewer {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
			}
			timelines {
				id
				createdAt
				user {
					id
					username
					fullName
					fullNameKhmer
				}
				action
				description
			}
			isDepartmentLevel
		}
	}
`;

const Q_SIGNS = gql`
	query getNpSigns($id: String!) {
		getNpSigns(id: $id) {
			id
			createdAt
			userCreatedBy {
				id
				username
				fullName
				fullNameKhmer
				avatar
			}
			createdBy
			position
			reviewer
			userReviewer {
				id
				username
				fullName
				fullNameKhmer
				avatar
				role
				position
				office
				department
			}
			decision
			decisionAt
			signature
			signatureImage
			miscellaneous
			decisionFile
		}
	}
`;

function NoteOfPresentationPreviewModal({ id = null, title = null, onClose = () => null, isPreviewing = true, showBorder = true }) {
	const { t } = useTranslation();
	const [loadDetail, { loading: loadingDetail, data: dataDetail }] = useLazyQuery(Q_DETAIL);
	const [loadSigns, { data: dataSigns }] = useLazyQuery(Q_SIGNS);
	const [npData, setNpData] = useState(null);
	const [npSigns, setNpSigns] = useState(null);

	useEffect(() => {
		if (id) {
			loadDetail({ variables: { id } });
		}
	}, [id]);

	useEffect(() => {
		if (dataDetail?.getNpById) {
			setNpData(dataDetail?.getNpById);
			loadSigns({ variables: { id: dataDetail?.getNpById?.id } });
		}
	}, [dataDetail]);

	useEffect(() => {
		if (dataSigns?.getNpSigns) {
			let localNpSigns = [];
			let positions =
				dataDetail?.getNpById?.type === 'rp'
					? dataDetail?.isDepartmentLevel
						? rpDeptSigningFlows
						: rpSigningFlows
					: dataDetail?.isDepartmentLevel
					? npDeptSigningFlows
					: npSigningFlows;
			positions.forEach((position) => {
				let npSigns = dataSigns?.getNpSigns?.filter((e) => e?.position === position);
				localNpSigns.push({
					position,
					data: npSigns[0] || null,
				});
			});
			setNpSigns(localNpSigns);
		}
	}, [dataSigns]);

	return (
		<Modal size="5xl" isOpen={true} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{t(title)}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<DataLoading loading={loadingDetail} loadedData={npData}>
						{({ loadedData }) => (
							<center>
								<Box width="100%" mt="16px" mb="16px">
									<Print type={loadedData?.type} npData={loadedData} npSigns={npSigns} isPreviewing={isPreviewing} showBorder={showBorder} />
								</Box>
							</center>
						)}
					</DataLoading>
				</ModalBody>
				<ModalFooter />
			</ModalContent>
		</Modal>
	);
}

export default NoteOfPresentationPreviewModal;
